import $ from 'jquery';

const tableWrapperClass = 'box-table-scroll--travel-insurance';
const tableClass = 'table--travel-insurance';

const getEffectiveColumnCount = (row) =>
    Array.from(row.cells || []).reduce((columnCount, cell) => columnCount + (cell.colSpan || 1), 0);

const isTravelInsuranceTable = (table) => {
    const rows = Array.from(table.rows || []).slice(0, 3);

    if (rows.length < 2) {
        return false;
    }

    const columnCounts = rows.map(getEffectiveColumnCount);
    const expectedColumnCount = columnCounts[0];
    const hasStableColumnCount =
        expectedColumnCount >= 6 && columnCounts.every((count) => count === expectedColumnCount);
    const hasGroupedHeaders = rows
        .slice(0, 2)
        .some((row) => Array.from(row.cells || []).some((cell) => (cell.colSpan || 1) > 1));

    return hasStableColumnCount && hasGroupedHeaders;
};

export const init = ($target) => {
    $target.find('.white-box > div > table').each((_, table) => {
        if (!isTravelInsuranceTable(table)) {
            return;
        }

        $(table).addClass(tableClass).parent('div').addClass(tableWrapperClass);
    });
};
